import {createRouter, createWebHistory} from "vue-router";
import qs from "qs";
import authRoutes from "@/Routes/auth-routes";
import adminRoutes from "@/Routes/admin-routes";
import userRoutes from "@/Routes/user-routes";
import {useMainStore} from "@/Stores/store";
import {useSessionStorage} from "@vueuse/core";
import {useStorage} from "@vueuse/core";
import dayjs from "dayjs";
import User from "@/Models/User.ts";

const routes = [
    ...authRoutes,
    {
        path: "/admin",
        children: adminRoutes,
        beforeEnter: (to, from) => {
            // console.log(to, from);
        },
        meta: {layout: "admin"},
    },
    {
        path: "/",
        children: userRoutes,
        meta: {layout: "default"},
    },
    {path: "/:pathMatch(.*)*", component: () => import("@/Pages/404.vue")},
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    parseQuery: qs.parse,
    stringifyQuery: qs.stringify,
    scrollBehavior(to, from, savedPosition) {
        if (to.name === "feed" || to.name === "groups.show" || to.name === "questions.launch") {
            return {top: savedPosition?.top ?? 0};
        }
        return {top: 0};
    },
});

router.beforeEach(async (to, from, next) => {
    let $sessionUser = useSessionStorage("user", null);
    let $store = useMainStore();
    console.log(to.path, $store.user);
    const selectedGroupStorage = useStorage<string | null>("selected-group-id", null);
    if (!$store.user?.id && to.path !== "/login" && to.path !== "/register" && to.path !== "/reset-password") {
        try {
            const {
                data: {data},
            } = await axios.get(route("user"));
            console.log(data);
            $sessionUser.value = data.id;
            $store.user = data;
            const $user = new User(data);
            // Load user's groups into store

            $store.groups = data.groups || [];

            // Determine if user is privileged (admin/super-admin or group admin)
            const isPrivileged = data?.is_group_admin === true || $user.hasAnyRole(["admin", "super-admin"]);

            if ($store.groups.length) {
                const exists =
                    selectedGroupStorage.value && $store.groups.some((g: any) => g.id === selectedGroupStorage.value);
                if (!exists) {
                    selectedGroupStorage.value = $store.groups[0]?.id ?? null;
                }
            } else {
                selectedGroupStorage.value = null;
            }

            if (to.meta.layout !== "guest") {
                if (!isPrivileged) {
                    next({name: "feed", params: {group: selectedGroupStorage.value}});
                } else {
                    next();
                }
            } else {
                next({
                    name: "feed",
                    params: selectedGroupStorage.value ? {group: selectedGroupStorage.value} : undefined,
                });
            }
        } catch (e) {
            console.error(e, to.name);
            // alert(to.name);
            sessionStorage.removeItem("user");
            if (!to.name || !["register", "login", "reset-password", "forgot-password"].includes(to.name)) {
                sessionStorage.setItem("intended", to.path);
                next({name: "login"});
            } else {
                // alert(to.name);
                next();
            }
        }
    } else {
        // Notifications refresh logic
        if (dayjs($store.notifications.updated_at).isBefore(dayjs().subtract(10, "minutes"))) {
            $store.notifications.updated_at = null;
        }

        if ($store.user?.id && to.meta.layout === "guest") {
            next({name: "feed", params: {group: selectedGroupStorage.value}});
        } else {
            next();
        }
    }
});

router.afterEach((to, from) => {
    const toDepth = to.path.split("/").length;
    const fromDepth = from.path.split("/").length;
    to.meta.transition = toDepth < fromDepth ? "slide-right" : "slide-left";
});

export default router;
